import React from 'react';
import {
  Users,
  MessagesSquare,
  CalendarDays,
  QrCode,
  ClipboardCheck,
  Sparkles,
} from 'lucide-react';
import LandingFeatureCard from './LandingFeatureCard';
import LandingSection from './LandingSection';
import Reveal from './Reveal';
import { APP_URL } from './urls';
import { useT } from './i18n';

const featureIcons = [Users, MessagesSquare, CalendarDays, QrCode, ClipboardCheck, Sparkles];

const LandingEmployer = () => {
  const t = useT();
  const features = t('employer.features');

  return (
    <LandingSection id="funkcie" variant="gray">
      <Reveal>
        <div className="landing-section-intro landing-section-intro--center">
          <h2 className="landing-h2">{t('employer.title')}</h2>
          <p className="landing-text landing-text--center" style={{ marginBottom: 0 }}>
            {t('employer.leadBefore')}{' '}
            <a href={APP_URL} className="landing-link">{t('employer.leadLink')}</a>
            {' '}{t('employer.leadAfter')}
          </p>
        </div>
      </Reveal>

      <div className="landing-cards-grid">
        {features.map((item, index) => (
          <LandingFeatureCard
            key={item.title}
            icon={featureIcons[index]}
            title={item.title}
            description={item.description}
            delay={index * 0.05}
          />
        ))}
      </div>
    </LandingSection>
  );
};

export default LandingEmployer;
